import { Deal } from 'scenes/Dashboard/data/deals/types'
import { Organization } from 'scenes/Dashboard/data/organizations/types'

export type OrganizationDetailsModalState = {
  readonly show: boolean
  readonly isAdmin: boolean
  readonly isLoading: boolean
  readonly isSubmitting: boolean
  readonly isInEditMode: boolean
  readonly dealId: Deal['id'] | null
  readonly organizationId: Organization['id'] | null
}

export const ORGANIZATION_DETAILS_MODAL_STORE_ID = 'OrganizationDetailsModal'
